/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hood_Edge_BodyInputs */

const en_hood_edge_body = /** @type {(inputs: Hood_Edge_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A small worker for every domain, on Cloudflare, next to the database.`)
};

/**
* | output |
* | --- |
* | "A small worker for every domain, on Cloudflare, next to the database." |
*
* @param {Hood_Edge_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hood_edge_body = /** @type {((inputs?: Hood_Edge_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hood_Edge_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hood_edge_body(inputs)
});